import {pick, assign} from 'lodash';
import FormModel from '@baidu/ve-ria/views/FormModel';

export default class CaseCreateView extends FormModel {
    /**
    * @override
    */
    title = '';

    /**
    * @override
    */
    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            text: '新建AR服务'
        }
    ];

    /**
     * @override
     */
    formData = {
        title: '',
        imageUrl: '',
        serviceId: '',
        templateId: '',
        description: ''
    };

    stepsInfo = {
        data: [],
        current: 1
    };

    // 取值为 case | material
    ARType = '';

    // 模板详情数据
    spec = [];
    // 本来想复用 pageType ，这里还是单独做吧
    isCopy = false;

    // component map
    componentMap = this.getConstantMap('AR_RESOURCE_TYPE');

    // aceeptMap
    acceptMap = this.getConstantMap('AR_RESOURCE_SUFFIX');

    /**
     * @override
     */
    init() {
        super.init();

        if (this.pageType === 'create') {
            this.createRequester = this.api.appServiceARCaseEdit;
        }
        else if (this.pageType === 'edit') {
            this.detailRequester = this.api.appServiceARDetail;
            this.updateRequester = this.api.appServiceARCaseEdit;
        }

        this.isAdmin = !!this.getRouteMeta().isAdmin;
        const query = this.getRouteQuery();
        const params = this.getRouteParams();
        this.id = params.serviceId;
        this.isCopy = query.type === 'copy';
        this.formData = assign(this.formData, pick(query, 'templateId'), params);
        // 设置信息
        this.setArType();
        // 设置 stepsData 和 crumbData
        this.setCrumbData();
        this.stepsInfo = this.getStepsData();
    }

    formData = {
        title: '',
        imageUrl: '',
        serviceId: '',
        templateId: '',
        description: ''
    };

    /**
     * @override
     */
    prepareData(data) {
        const original = {};
        const keys = ['title', 'serviceId', 'description'];

        if (this.ARType === 'material') {
            keys.push('templateId');
            original.settings = this.genComplexParam(data);
        }
        else if (this.pageType === 'create') {
            keys.push('templateId');
        }

        return {
            ...original,
            ...pick(data, keys)
        };
    }

    genComplexParam(data) {
        let result;
        if (this.pageType === 'edit') {
            result = JSON.parse(data.settings);
            result.forEach(item => {
                const key = item.id;
                item.targetInputValue = data[key];
            });
        }
        else {
            result = this.spec.map(item => {
                const obj = {
                    id: item.name,
                    type: item.type,
                    targetInputValue: data[item.name]
                };
                if (item.component === 'veui-uploader') {
                    obj.materId = this.id;
                }
                return obj;
            });
        }
        return JSON.stringify(result);
    }

    /**
     * @override
     */
    adaptData(data) {
        if (this.ARType === 'material') {
            this.getTemplateInfo(this.formData.serviceId);
        }
        return assign(
            this.formData,
            pick(data.serviceData, ['description', 'imageUrl', 'title', 'templateId', 'settings'])
        );
    }

    /**
     * @override
     */
    submit(data) {
        if (this.pageType === 'create' && this.createRequester) {
            return this.requestCreate(data);
        }

        if (this.pageType === 'edit' && this.updateRequester) {
            return this.requestUpdate(data);
        }

        if (this.pageType === 'copy') {
            return this.requestCreate(data);
        }
        throw new Error(`unknown form page type: ${this.pageType}!`);
    }

    setArType() {
        const path = this.getRoutePath().split('/');

        this.ARType = path[path.length - 2];
        if (this.pageType === 'edit') {
            if (this.ARType === 'material') {
                this.updateRequester = this.api.appServiceARMaterialSubmit;
            }
        }
        else if (this.ARType === 'material') {
            this.createRequester = this.api.appServiceARMaterialSubmit;
        }
        this.templateInfo = this.api.appServiceARTemplateDetail;
    }

    getStepsData() {
        if (this.pageType === 'create' || this.ARType === 'material') {
            return {
                data: [
                    {
                        label: '填写基本信息'
                    },
                    {
                        label: '选择AR模板'
                    },
                    {
                        label: '配置AR物料'
                    },
                    {
                        label: '预览AR物料'
                    }
                ],
                current: 2
            };
        }
        return {
            data: [
                {
                    label: '填写基本信息'
                },
                {
                    label: '配置AR物料'
                },
                {
                    label: '预览AR物料'
                }
            ],
            current: 1
        };
    }

    setCrumbData() {
        if (this.pageType === 'edit') {
            this.crumbData[1].text = '编辑AR服务';
        }
        if (this.isCopy) {
            this.crumbData[1].text = '复制AR服务';
        }

        this.crumbData[0].to = this.isAdmin ? '/service/reviewing/list' : '/app/service/list';
    }

    async getTemplateInfo(templateId) {
        const data = await this.templateInfo({
            templateId
        });
        let map = {};
        if (this.ARType === 'material' && this.pageType === 'edit') {
            const settings = JSON.parse(this.formData.settings);
            map = settings.reduce((map, item) => {
                map[item.id] = item.targetInputValue;
                return map;
            }, {});
        }

        this.spec = data.spec.map(item => {
            // 填充默认值
            if (this.ARType === 'material') {
                this.formData[item.id] = map[item.id];
            }

            const result = {
                name: item.id,
                type: item.type,
                title: item.title,
                required: item.is_not_empty,
                value: item.targetInputValue,
                description: item.description,
                accept: this.acceptMap[item.type],
                component: this.componentMap[item.type]
            };
            if (item.materId) {
                result.materId = item.materId;
            }
            return result;
        });
    }
}
